"use strict";
import { Language, mapLocaleToLanguage } from "features/language/constants";
import { navigatorLocale } from "features/language/hooks";
export function getCurrentLanguageFromNavigator() {
  const locale = navigatorLocale();
  return locale ? mapLocaleToLanguage[locale] : Language.English;
}
